import Urls from "../../constants/urls";
import entrance from "./imgs/entrance.jpeg";
import mainRoom from "./imgs/mainRoom.jpeg";
import corridor from "./imgs/corridor.jpeg";
import smallRoom from "./imgs/smallRoom.jpeg";

export const homeUrl = Urls.virtualGallery.entrance.path;

export const shopifyData = {
  domain: "dirtysocks-ltd.myshopify.com",
  token: "3b5881ce6d9fa84499494e54e993e643",
  productIds: ["5868745523354", "6101728002218"],
};

export const calendarId = "kahlilashanti"

export const entranceHotspots = [
  {
    type: "info",
    xPosition: -2.5,
    yPosition: 2,
    zPosition: -5,
    text: "Enter information here."
  },
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 90,
    xRotation: -90,
    yRotation: 90,
    zRotation: 180,
    radius: 10,
    link: Urls.virtualGallery.mainRoom.path,
    linkRotation: 55,
  },
  {
    type: "cart",
    xPosition: -16,
    yPosition: -0.5,
    zPosition: 1.5,
    yRotation: 90,
    radius: 0.75,
    productId: "5868745523354",
  },
];

export const rooms = [
  {
    name: "Entrance",
    img: entrance,
    route: Urls.virtualGallery.entrance,
    yRotation: 360,
  },
  {
    name: "Main Room",
    img: mainRoom,
    route: Urls.virtualGallery.mainRoom,
    yRotation: 360,
    linkRotation: 55,
  },
  {
    name: "Corridor",
    img: corridor,
    route: Urls.virtualGallery.corridor,
    yRotation: -88,
  },
  {
    name: "Small Room",
    img: smallRoom,
    route: Urls.virtualGallery.smallRoom,
    yRotation: 90,
  },
];
